import { HttpClient } from "../HttpClient";

export const PatchCreditStatus = async (id, payload) => {
  try {
    const response = await HttpClient.patch(
      `api/subscriptions/CreditStatus/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error updating credit status:", error);
    return {
      success: false,
      message:
        error.response?.data?.detail || "Failed to update credit status.",
    };
  }
};
